import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions, businessOptions } from './PrivateCloudSupportFormOptions';

export const getPrivateCloudSupportFormData = (target, helpWith, helpWithSecondary, helpWithThird, companyName) => {
    let namespace: string = '';
    let subject: string = '';
    const category = "HPE GreenLake for Private Cloud";

    if (helpWith === helpWithOptions.ai) {
      namespace = 'hpe_pcai';
      subject = `${helpWith} {formId}`;
    }

    if (helpWith === helpWithOptions.business) {
      switch (helpWithSecondary) {
        case businessOptions.dhci:
          namespace = 'hpe_dssupport_alletra6000';
          subject = `Support request (form): ${helpWith}, ${helpWithSecondary}, ${companyName}`;
          break;
        case businessOptions.alletraStorageBlock:
          namespace = 'hpe_storage_alletra_mp_all';
          subject = `Support request (form): ${helpWith}, ${helpWithSecondary}, ${companyName}`;
          break;
        case businessOptions.simpliVity:
          namespace = 'hpe_pcbe_simplivity';
          subject = `${helpWith}, ${helpWithSecondary}, {formId}`;
          break;
      }
    }

    if (helpWith === helpWithOptions.enterprise) {
      namespace = 'hpe_pce';
      subject =  `PCE : ${helpWithSecondary} || ${helpWithThird} - {formId}`;
    }

  return getSortedFormFields(target, namespace, subject, category);
};
